import { mapGetters, mapMutations } from "vuex";
import { Carousel, Slide } from "vue-carousel";

export default {
  name: "notify-product",
  props: {
    products: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    Carousel,
    Slide,
  },
  computed: {
    ...mapGetters({
      user: "profile/user",
    }),
    notificationProducts() {
      if (!this.user || !this.user.notificationProducts || !this.user.notificationProducts.data) {
        return [];
      }
      return this.user.notificationProducts.data;
    },
    hasProducts() {
      return this.notificationProducts && this.notificationProducts.length > 0;
    },
  },
  created() {
    if (this.user?.notificationProducts?.data) {
      console.log(this.user.notificationProducts.data);
    }
  },
  watch: {
    $route: {
      handler() {
        this.closeModal();
      },
      deep: true,
    },
  },
  methods: {
    ...mapMutations({
      addToBasket: "basket/ADD_ITEM_TO_BASKET",
    }),
    closeModal() {
      this.$emit("close");
    },

    goToShop() {
      this.$router.push(this.$localize({ name: "products" }));
      this.closeModal();
    },

    addToCart(product) {
      this.addToBasket({
        product: product,
        select_count: 1,
        product_price: product.productPrices.data[0],
      });
      this.$toasted.success("Товар успішно додано в кошик!");
    },

    resolveProductImage(product) {
      if (product.image) {
        return product.image;
      } else if (product.images && product.images.length > 0) {
        return product.images[0];
      } else {
        return "/img/product-placeholder.jpg";
      }
    },
  },
};
